'use strict'

export class DonationAmount {
	constructor() {
		const user_paying_currency_switcher = document.getElementById('user_paying_currency');
		const custom_amount_input = document.getElementById('custom_amount');
		const one_time_donation_tab = document.querySelector('.one_time_donation_button');
		const monthly_donation_tab = document.querySelector('.monthly_donation_button');
		const checkout_tabs = document.querySelector('.levcharity_checkout_tabs[data-default]');

		if (checkout_tabs?.dataset?.default == 'monthly') {
			custom_amount_input.placeholder = wp.i18n.__("Other Monthly Amount", "levcharity");
		}

		if (user_paying_currency_switcher) {
			let currency_value = user_paying_currency_switcher.value;
			if (currency_value) {
				this.changeCurrencySymbolForLabels(currency_value, user_paying_currency_switcher, custom_amount_input);
			}
			user_paying_currency_switcher.addEventListener('change', (event) => {
				let selected_currency = event.target.value;
				this.changeCurrencySymbolForLabels(selected_currency, user_paying_currency_switcher, custom_amount_input);
			});
			if (one_time_donation_tab) {
				one_time_donation_tab.addEventListener('click', e => {
					this.changeCurrencySymbolForLabels(user_paying_currency_switcher.value, user_paying_currency_switcher, custom_amount_input);
					if (custom_amount_input) {
						custom_amount_input.placeholder = wp.i18n.__("Other amount", "levcharity");
					}
				})
			}
			if (monthly_donation_tab) {
				monthly_donation_tab.addEventListener('click', e => {
					this.changeCurrencySymbolForLabels(user_paying_currency_switcher.value, user_paying_currency_switcher, custom_amount_input);
					if (custom_amount_input) {
						custom_amount_input.placeholder = wp.i18n.__("Other Monthly Amount", "levcharity");
					}
				})
			}
		}
	}

	changeCurrencySymbolForLabels(currency_value, user_paying_currency_switcher, custom_amount_input) {
		let option = user_paying_currency_switcher.querySelector(`option[value="${currency_value}"]`);
		if (option) {
			let currency_symbol = option.getAttribute('data-symbol');
			setTimeout(() => {
				if (currency_symbol) {
					let labels_for_currency_symbol = document.querySelectorAll('span.currency_symbol');
					let labels_for_currency_name = document.querySelectorAll('span.currency_name');

					if (labels_for_currency_symbol) {
						labels_for_currency_symbol.forEach((label) => {
							label.innerText = currency_symbol;
						});
					}
					if (custom_amount_input) {
						custom_amount_input.setAttribute('data-currency', currency_value);
						document.querySelector("label.currency_symbol").innerText = currency_symbol
					}
					if (labels_for_currency_name) {
						labels_for_currency_name.forEach((label) => {
							label.innerText = currency_value;
						});
					}
				}
			}, 100)
		}
	}

}
